import { FC, memo, useCallback, useEffect, useMemo } from 'react';
import { useUnmount } from 'react-use';

import { CheckDuplicatePopup } from './CheckDuplicatePoup/CheckDuplicatePopup';
import { CheckDuplicatesProps } from './CheckDuplicates.types';

export const CheckDuplicate: FC<CheckDuplicatesProps> = memo((props) => {
    const { onSuccess, onCancel, onSuccessText, companyId, duplicateData } = props;
    const { data, isLoading, remove, error } = duplicateData;

    useUnmount(remove);

    const onSuccessAndClosePoup = useCallback(() => {
        onSuccess(data?.items);
        onCancel();
    }, [data?.items, onCancel, onSuccess]);

    const filtereDuplicates = useMemo(
        () =>
            (data?.items || []).filter(({ requestId }) =>
                props.currentRequestId ? requestId !== props.currentRequestId : true
            ),
        [data?.items, props.currentRequestId]
    );

    const isNoDuplicates = filtereDuplicates.length === 0;
    const hasDuplicatesData = Boolean(data?.items);

    useEffect(() => {
        if ((hasDuplicatesData && isNoDuplicates) || error) onSuccessAndClosePoup();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isNoDuplicates, error, hasDuplicatesData]);

    if (isNoDuplicates || isLoading) return null;

    return (
        <CheckDuplicatePopup
            companyId={companyId}
            duplicates={filtereDuplicates}
            onCancel={onCancel}
            onSuccess={onSuccessAndClosePoup}
            onSuccessText={onSuccessText}
        />
    );
});

CheckDuplicate.displayName = 'CheckDuplicate';
